/**
 * Logger utility for daily-task-coordination module
 * Provides conditional logging based on environment
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugEnabled = localStorage.getItem('debug_enabled') === 'true';

const logger = {
  /**
   * Debug level - disabled for performance
   */
  debug: (...args) => {
    // Debug logs disabled - uncomment if needed for troubleshooting
    // if (isDevelopment || isDebugEnabled) {
    //   console.log('[DEBUG]', new Date().toISOString(), ...args);
    // }
  },

  /**
   * Info level - general information
   */
  info: (...args) => {
    console.info('[INFO]', new Date().toISOString(), ...args);
  },

  /**
   * Warning level - non-critical issues
   */
  warn: (...args) => {
    console.warn('[WARN]', new Date().toISOString(), ...args);
  },

  /**
   * Error level - critical issues
   */
  error: (...args) => {
    console.error('[ERROR]', new Date().toISOString(), ...args);

    // TODO: Integrate with error tracking service (Sentry, LogRocket, etc.)
    // if (window.Sentry) {
    //   window.Sentry.captureException(args[0]);
    // }
  },

  /**
   * Group logging for related operations
   */
  group: (label, callback) => {
    if (isDevelopment || isDebugEnabled) {
      console.group(label);
      callback();
      console.groupEnd();
    }
  },

  /**
   * Performance timing
   */
  time: (label) => {
    if (isDevelopment || isDebugEnabled) {
      console.time(label);
    }
  },

  timeEnd: (label) => {
    if (isDevelopment || isDebugEnabled) {
      console.timeEnd(label);
    }
  }
};

export default logger;
